export default "__VITE_ASSET__BnVXW3BV__"